'use strict';
import {Infoblock} from './infoblock.js';
export class InfoblockBusinesshours extends Infoblock {
	constructor(component_id) {
		super(component_id);
		this.data  = yalwa.v.components[this.id].data;
		this.vue_data_vars = {
			businessHours: structuredClone(this.data.businessHours || []),
			hasData: structuredClone(this.data.hasData),
			businessHoursDB: structuredClone(this.data.businessHours || []),
			categories: this.data.categories
		};
		this.vue_method_vars = {
			saveIconBoxData() {
				this.is_saving = true;
				//Store in DB
				yalwa.basics.ajaxservice({
					type: 'POST',
					resource: 'profileupdate',
					action: 'update_business_hours',
					data: {
						data: JSON.stringify(this.businessHours)
					},
					include_session: true
				}).then(response => {
					
					if (response.type === 'success') {
						if (response.vip_completion) {
							document.dispatchEvent(new CustomEvent('vip_guide_state', {detail: response.vip_completion}));
						}
						this.businessHoursDB = structuredClone(response.businessHours);
						this.close();
					}
					
					yalwa.basics.toast({
						message: response.label,
						type: response.type
					});
					
				}).finally(() => {
					this.is_saving = false;
				});
				
				this.hasData = true;
			},
			resetLocalWorkingCopy() {
				this.businessHours = JSON.parse(JSON.stringify(this.businessHoursDB));
			},
			selectSlot(day, index) {
				switch (this.businessHours[day.day].category) {
					//Specific Hours
					case 1:
						this.businessHours[day.day].slots = [{start_time : '00:00', end_time : '00:00'}];
						break;
					//All Day
					case 2:
						this.businessHours[day.day].slots = {};
						break;
					//Closed
					case 3:
						this.businessHours[day.day].slots = {};
						break;

				}
			
			},
			deleteRecord(day ) {
				this.businessHours[day.day].category = 1;
				this.businessHours[day.day].deleted = true;
				this.businessHours[day.day].slots = [{start_time : '00:00', end_time : '00:00'}];
			},
			close() {
				this.resetLocalWorkingCopy();
				this.closeDialog();
			},
			addMoreSlot(day, key) {
				this.businessHours[day.day].slots.push({start_time : '00:00', end_time : '00:00'});
			},
			deleteThisSlot(day, key) {
				//todo first do ajax
				this.businessHours[day.day].slots.splice(key, 1);
			}
		};
		this.extras = {
			computed : {
				isUnchanged() {
					return JSON.stringify(this.businessHours) ===
						JSON.stringify(this.businessHoursDB);
				}
			},
			mounted() {
				jQuery('.js-business_hour_toggle').on('click', (e) => {
					const $this = jQuery(e.currentTarget);
					const $content = $this.next('.js-business_hour_toggle_body');
					
					// 1. Target your specific scrollable wrapper
					const $container = $this.closest('.js-businesshours_content');
					
					$this.find('.js-business_hour_toggle_info').toggleClass('v_hidden');
					
					const isExpanding = !$content.is(':visible');
					
					// 2. Start the slide animation
					$content.slideToggle(400);
					
					// 3. Handle the container scrolling concurrently
					if (isExpanding) {
						// Calculate the distance from the top of the container's VISIBLE area to the clicked item
						const relativeTop = $this.offset().top - $container.offset().top;
						
						// Only scroll if the item is pushed further down the container (e.g., more than 50px from the top)
						// If it's already at the top (relativeTop is small), it won't trigger the scroll.
						if (relativeTop > 50) {
							$container.animate({
								// Calculate the new scroll position by adding the distance to the current scroll
								scrollTop: $container.scrollTop() + relativeTop - 10 // 10px buffer
							}, 400);
						}
					}
				});
			}
		}
	}
	setup_vars(Vue) {
		// this.businessHours = Vue.ref(this.data.businessHours);
		 this.businessHoursDB = Vue.ref('');
		 this.businessHours = Vue.ref('');
	}
}